/**
 * @generated SignedSource<<4bc2b449e2e7687e599613892bb2f93d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountName"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountTypes"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "email"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "emailVerified"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last4"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderDirection"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "statusValues"
},
v10 = [
  {
    "kind": "Variable",
    "name": "accountName",
    "variableName": "accountName"
  },
  {
    "kind": "Variable",
    "name": "accountTypes",
    "variableName": "accountTypes"
  },
  {
    "kind": "Variable",
    "name": "email",
    "variableName": "email"
  },
  {
    "kind": "Variable",
    "name": "emailverified",
    "variableName": "emailVerified"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "last4",
    "variableName": "last4"
  },
  {
    "kind": "Variable",
    "name": "offset",
    "variableName": "offset"
  },
  {
    "kind": "Variable",
    "name": "orderby",
    "variableName": "orderBy"
  },
  {
    "kind": "Variable",
    "name": "orderdirection",
    "variableName": "orderDirection"
  },
  {
    "kind": "Variable",
    "name": "statusvalues",
    "variableName": "statusValues"
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v10/*: any*/),
        "concreteType": "AccountTsConnection",
        "kind": "LinkedField",
        "name": "adminaccountsearch",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AccountList_al"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/),
      (v9/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "AccountsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v10/*: any*/),
        "concreteType": "AccountTsConnection",
        "kind": "LinkedField",
        "name": "adminaccountsearch",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountT",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accountId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accountType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "contactEmail",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accountNum",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accountName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accountStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "floatLimit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxCharge",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "created",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4cb1fd9ae06bb1c6b97f0af4c02b2735",
    "id": null,
    "metadata": {},
    "name": "AccountsQuery",
    "operationKind": "query",
    "text": "query AccountsQuery(\n  $accountName: String\n  $email: String\n  $accountTypes: [Int]\n  $last4: String\n  $emailVerified: Int\n  $statusValues: [Int]\n  $orderBy: Int\n  $orderDirection: Int\n  $first: Int\n  $offset: Int\n) {\n  adminaccountsearch(accountName: $accountName, email: $email, accountTypes: $accountTypes, emailverified: $emailVerified, statusvalues: $statusValues, orderby: $orderBy, orderdirection: $orderDirection, last4: $last4, first: $first, offset: $offset) {\n    totalCount\n    ...AccountList_al\n  }\n}\n\nfragment AccountList_al on AccountTsConnection {\n  nodes {\n    accountId\n    accountType\n    contactEmail\n    accountNum\n    accountName\n    description\n    accountStatus\n    floatLimit\n    maxCharge\n    created\n    nodeId\n  }\n}\n"
  }
};
})();

node.hash = "2e44411d439a13790e96a63ad12ed92a";

module.exports = node;
